import React from "react";
import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

// Webapp Routes
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import ContactUs from "./pages/ContactUs";
import Support from "./pages/Support";
import Signup from "./pages/auth/Signup";
import Forgot from "./pages/auth/Forgot";
import ForgotOtp from "./pages/auth/ForgotOtp";

// Dashboard Routes
import Dashbaord from "./pages/Dashbaord";
import ManageAccount from "./components/ManageAccount";
import Billing from "./pages/Billing";
import Plans from "./pages/Plans";
import Docs from "./pages/Docs";
import Ticket from "./pages/Ticket";
import InvoiceDetail from "./pages/InvoiceDetail";
import Feedback from "./pages/Feedback";
import ResetPassword from "./pages/auth/ResetPassword";
import Signin from "./pages/auth/Signin";
import VerifyOtp from "./pages/auth/VerifyOtp";
import Chatbot from "./components/Chatbot/Chatbot";
import ChatPopup from "./components/Chatbot/ChatPopup";
import Chatbotkit from "./components/Chatbotkit/Chatbotkit";

function App() {
  return (
    <div>
      <Router>
        <ChatPopup />
        <Chatbotkit />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/support" element={<Support />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/sign-in" element={<Signin />} />
          <Route path="/forgot-password" element={<Forgot />} />
          <Route path="/forgot-otp" element={<ForgotOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/dashboard" element={<Dashbaord />} />
          <Route path="/manage-account" element={<ManageAccount />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/invoice-detail" element={<InvoiceDetail />} />
          <Route path="/documentation" element={<Docs />} />
          <Route path="/feedback" element={<Feedback />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
